import { configureStore, combineReducers } from '@reduxjs/toolkit';
import {
  persistStore,
  persistReducer,
  FLUSH,
  REHYDRATE,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER,
} from 'redux-persist';
import storage from 'redux-persist/lib/storage';

import rootReducer from './rootReducer';

const authPersistConfig = {
  key: 'auth',
  storage,
  whitelist: ['user'],
};

const settingsPersistConfig = {
  key: 'settings',
  storage,
  whitelist: ['settings'],
};

const dashboardPersistConfig = {
  key: 'dashboard',
  storage,
};

const permissionsPersistConfig = {
  key: 'permissions',
  storage,
};

const sidebarPersistConfig = {
  key: 'sidebar',
  storage,
};

const persistedReducer = combineReducers({
  user: persistReducer(authPersistConfig, rootReducer.userReducer),
  settings: persistReducer(settingsPersistConfig, rootReducer.settingReducer),
  permissions: persistReducer(permissionsPersistConfig, rootReducer.permissionReducer),
  dashboard: persistReducer(dashboardPersistConfig, rootReducer.dashboardReducer),
  sidebar: persistReducer(sidebarPersistConfig, rootReducer.sidebarReducer)
});

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }),
});

export const persistor = persistStore(store);